import { useState } from 'react';
import type { PlanAppMode, PlanningSelectionInfo } from '../../../types/planManagement';

export const usePlanEditorState = (initialMode: PlanAppMode = 'planning') => {
  const [appMode, setAppMode] = useState<PlanAppMode>(initialMode);
  const [isDragging, setIsDragging] = useState(false);
  const [selectionStart, setSelectionStart] = useState<{ row: number; col: number } | null>(null);
  const [selectionEnd, setSelectionEnd] = useState<{ row: number; col: number } | null>(null);
  const [multiSelectedBeds, setMultiSelectedBeds] = useState<Set<string>>(new Set());
  const [multiSelectedPlots, setMultiSelectedPlots] = useState<Set<string>>(new Set());
  const [plantingModalVisible, setPlantingModalVisible] = useState(false);
  const [selectedBedForPlanting, setSelectedBedForPlanting] = useState<string | null>(null);
  const [planningSelection, setPlanningSelection] = useState<PlanningSelectionInfo | null>(null);
  const [isEraseMode, setIsEraseMode] = useState(false);
  const [bulkPlacementModalVisible, setBulkPlacementModalVisible] = useState(false);
  const [isBulkPlacementMode, setIsBulkPlacementMode] = useState(false);
  const [bulkGridDimensions, setBulkGridDimensions] = useState<{ rows: number; cols: number } | null>(null);
  const [selectedCropForBulk, setSelectedCropForBulk] = useState<string | null>(null);
  const [bulkPlacementHoverPos, setBulkPlacementHoverPos] = useState<{ row: number; col: number } | null>(null);

  const clearDragSelection = () => {
    setSelectionStart(null);
    setSelectionEnd(null);
  };

  const clearMultiSelection = () => {
    setMultiSelectedBeds(new Set());
    setMultiSelectedPlots(new Set());
  };

  const closePlantingModal = () => {
    setPlantingModalVisible(false);
    setSelectedBedForPlanting(null);
  };

  return {
    appMode,
    setAppMode,
    isDragging,
    setIsDragging,
    selectionStart,
    setSelectionStart,
    selectionEnd,
    setSelectionEnd,
    multiSelectedBeds,
    setMultiSelectedBeds,
    multiSelectedPlots,
    setMultiSelectedPlots,
    plantingModalVisible,
    setPlantingModalVisible,
    selectedBedForPlanting,
    setSelectedBedForPlanting,
    planningSelection,
    setPlanningSelection,
    isEraseMode,
    setIsEraseMode,
    bulkPlacementModalVisible,
    setBulkPlacementModalVisible,
    isBulkPlacementMode,
    setIsBulkPlacementMode,
    bulkGridDimensions,
    setBulkGridDimensions,
    selectedCropForBulk,
    setSelectedCropForBulk,
    bulkPlacementHoverPos,
    setBulkPlacementHoverPos,
    clearDragSelection,
    clearMultiSelection,
    closePlantingModal,
  };
};
